/*$(document).ready(function(){
  $(".filter_style").change(function(){
    var chk = $(this).val();
    if(chk !=""){
      var str = "";
      $(".filter_material option").css('display','block');
      $(".filter_material option").each(function(){
        if(chk == $(this).data('val'))			
          $(this).css('display','block');
        else
          $(this).css('display','none');
      });
    }
    else{
      $(".filter_material option").css('display','block');
    }
  });
});*/

$(document).ready(function(){
  $(".filter_style").change(function(){
    var chk = $(this).val();
    if(chk !=""){
      var str = "";
      $(".filter_material option").css('display','block');
      $(".filter_material option").each(function(){
        var chk1 = $(this).val();
        if( chk1 != ""){
          var str =$(this).data('val');
          var res = str.split(" "); 
          if(res.indexOf(chk) != -1){
            return true;
          }
          if(chk == res){
            $(this).css('display','block');
          }
          else{
            $(this).css('display','none');
          }
        }
      });
    }
    else{
      $(".filter_material option").css('display','block');
    }
  });
});
        
        
var filter_style = '';var filter_type = '';

function filter_shows()
{
  $(".collectionItem").hide();
  
  if(filter_style != '' && filter_type == '')
  {
    $("li[data-style='"+filter_style+"']").show();
  }
  else if(filter_style == '' && filter_type != '')
  {
    $("li[data-style='"+filter_type+"']").show();
  }
  else if(filter_style != '' && filter_type != '')
  {
    $("li[data-styletype='"+filter_style+"-"+filter_type+"']").show();
  }
  else
  {
    $(".collectionItem").show();
  }
}


 function compare_a_z(a, b){ 
 var compA = $(a).data('alpha'); 
 var compB = $(b).data('alpha'); 
 return (compA < compB) ? -1 : (compA > compB ) ? 1 : 0; 
 } 
 
 function compare_z_a(a, b){ 
 var compA = $(a).data('alpha'); 
 var compB = $(b).data('alpha'); 
 return (compA > compB) ? -1 : (compA < compB ) ? 1 : 0; 
 } 
 
 function compare_l_h(a, b){ 
 var compA = $(a).data('price'); 
 var compB = $(b).data('price'); 
 return (compA < compB) ? -1 : (compA > compB ) ? 1 : 0; 
 } 
 
 function compare_h_l(a, b){ 
 var compA = $(a).data('price'); 
 var compB = $(b).data('price'); 
 return (compA > compB) ? -1 : (compA < compB ) ? 1 : 0; 
 } 
 
$( document ).ready(function() { 
 
// on sortBox change collect the products 
 $('select#sortBox').change(function(){
   console.log('Click Event...............');
 arr = []; 
 sort_func = $(this).children(':selected').val(); 
 
 $('li.collectionItem').each(function(){ 
   console.log('Element....:'+sort_func);
   arr.push(this); 
 }); 
 
  
   // find which sort was selected and run the right sort function 
 if (sort_func == "a_z"){ 
 arr.sort(compare_a_z); 
 } 
 else if (sort_func == "z_a"){ 
 arr.sort(compare_z_a); 
 } 
 else if (sort_func == "l_h"){ 
 arr.sort(compare_l_h); 
 } 
 else if (sort_func == "h_l"){ 
 arr.sort(compare_h_l); 
 } 
 // push the arranged products back out 
 $('#col_product').append(arr); 
  // reset Lazy Loading just in case images sorted to top fail to show 
 //setLazy(); 
 }); 
  

  //filter_style
  $('select#filter_style').change(function(){
		filter_style = $(this).children(':selected').val(); 
		filter_shows();
  }); 
  

  $('select#filter_material').change(function(){
    filter_type = $(this).children(':selected').val(); 
	filter_shows()
  }); 

  
});
